module.exports = __webpack_public_path__ + "static/581-a58a00884defac2a90f72cce531600a6.png";